import { arrayOf, node, shape, string } from "prop-types";
import StyledLink from "../StyledLink/StyledLink.jsx";
import useMatchMedia from "../../common/useMatchMedia.js";

const propTypes = {
  title: string,
  description: node,
  promos: arrayOf(
    shape({
      title: string.isRequired,
      description: node.isRequired,
      link: string.isRequired,
      linkTarget: string,
      images: shape({
        mobile1X: string.isRequired,
        desktop1X: string.isRequired,
        mobile2X: string.isRequired,
        desktop2X: string.isRequired,
        alt: string,
      }),
    }).isRequired,
  ).isRequired,
};
const MultiPromoC = (props) => {
  const { title, description, promos } = props;

  const isDesktop = useMatchMedia("(min-width: 1060px)");

  const featuredPromo = promos.slice(0, 1)[0];

  return (
    <>
      {!isDesktop && (
        <div className="multi-promo__hr">
          <hr data-aos="border-grow" data-aos-once="true" />
        </div>
      )}
      <section className="multi-promo-c">
        <div className="multi-promo-c__header">
          {title && <h2 className="multi-promo-c__title">{title}</h2>}
          {description && (
            <div className="multi-promo-c__description">
              <div dangerouslySetInnerHTML={{ __html: description }}></div>
            </div>
          )}
        </div>
        {featuredPromo && (
          <div className="multi-promo-c__featured-promo">
            <div className="multi-promo-c__featured-content">
              <h4 className="multi-promo-c__featured-title">
                {featuredPromo.link ? (
                  <StyledLink
                    href={featuredPromo.link}
                    target={featuredPromo.linkTarget}
                  >
                    {featuredPromo.title}
                  </StyledLink>
                ) : (
                  <span>{featuredPromo.title}</span>
                )}
              </h4>
              <div
                dangerouslySetInnerHTML={{ __html: featuredPromo.description }}
              ></div>
            </div>
            <div className="multi-promo-c__featured-image">
              {featuredPromo.link ? (
                <a href={featuredPromo.link} target={featuredPromo.linkTarget}>
                  <img
                    srcSet={`
                      ${featuredPromo.images.mobile1X} 250w,
                      ${featuredPromo.images.mobile2X} 500w,
                      ${featuredPromo.images.desktop1X} 714w,
                      ${featuredPromo.images.desktop2X} 1071w
                      `}
                    sizes="
                        (min-width: 1024px) 714px, 
                        calc(100vw - 70px)
                      "
                    src={featuredPromo.images.mobile1X}
                    alt={
                      featuredPromo.images.alt ? featuredPromo.images.alt : ""
                    }
                    loading="lazy"
                  />
                </a>
              ) : (
                <img
                  srcSet={`
                    ${featuredPromo.images.mobile1X} 250w,
                    ${featuredPromo.images.mobile2X} 500w,
                    ${featuredPromo.images.desktop1X} 714w,
                    ${featuredPromo.images.desktop2X} 1071w
                    `}
                  sizes="
                      (min-width: 1024px) 714px, 
                      calc(100vw - 70px)
                    "
                  src={featuredPromo.images.mobile1X}
                  alt={featuredPromo.images.alt ? featuredPromo.images.alt : ""}
                  loading="lazy"
                />
              )}
            </div>
          </div>
        )}
        <div className="multi-promo-c__promos">
          {promos.slice(1, promos.length).map((promo, i) => (
            <div className="multi-promo-c__promo" key={i}>
              <div className="multi-promo-c__promo-image">
                {promo.link ? (
                  <a href={promo.link} target={promo.linkTarget}>
                    <img
                      srcSet={`
                    ${promo.images.mobile1X} 250w,
                    ${promo.images.desktop1X} 342w,
                    ${promo.images.mobile2X} 500w,
                    ${promo.images.desktop2X} 700w
                  `}
                      sizes="
                      (min-width: 1115px) 342px, 
                      (min-width: 746px) calc((100vw - 70px - 80px) / 3), 
                      (min-width: 680px) calc((100vw - 70px - 40px) / 2),
                      (min-width: 420px) 342px, 
                      calc(100vw - 70px)
                    "
                      src={promo.images.mobile1X}
                      alt={promo.images.alt ? promo.images.alt : ""}
                      loading="lazy"
                    />
                  </a>
                ) : (
                  <img
                    srcSet={`
                  ${promo.images.mobile1X} 250w,
                  ${promo.images.desktop1X} 350w,
                  ${promo.images.mobile2X} 500w,
                  ${promo.images.desktop2X} 700w
                `}
                    sizes="
                    (min-width: 1115px) 342px, 
                    (min-width: 746px) calc((100vw - 70px - 80px) / 3), 
                    (min-width: 680px) calc((100vw - 70px - 40px) / 2),
                    (min-width: 420px) 342px, 
                    calc(100vw - 70px)
                  "
                    src={promo.images.mobile1X}
                    alt={promo.images.alt ? promo.images.alt : ""}
                    loading="lazy"
                  />
                )}
              </div>

              <h5 className="multi-promo-c__promo-title">
                {promo.link ? (
                  <StyledLink href={promo.link} target={promo.linkTarget}>
                    {promo.title}
                  </StyledLink>
                ) : (
                  <span>{promo.title}</span>
                )}
              </h5>
              <div
                dangerouslySetInnerHTML={{ __html: promo.description }}
              ></div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

MultiPromoC.propTypes = propTypes;
export default MultiPromoC;
